//よくある質問アコーディオン
$('.accordion__btn').on('click', function () {
    $(this).next().slideToggle();
    if ($(this).hasClass('show')) {
        $(this).removeClass('show');
    } else {
        $(this).addClass('show');
    }
});

const slides = document.querySelector(".slides");
const slideCount = document.querySelectorAll(".slide").length;
const prevBtn = document.querySelector(".prev-btn");
const nextBtn = document.querySelector(".next-btn");
const dotsContainer = document.querySelector(".dots");
let currentIndex = 0;

// ドット生成
for (let i = 0; i < slideCount; i++) {
    const dot = document.createElement("div");
    dot.classList.add("dot");
    if (i === 0) dot.classList.add("active");
    dot.addEventListener("click", () => goToSlide(i));
    dotsContainer.appendChild(dot);
}
const dots = document.querySelectorAll(".dot");

function updateSlide() {
    slides.style.transform = `translateX(${-100 * currentIndex}%)`;
    dots.forEach(dot => dot.classList.remove("active"));
    dots[currentIndex].classList.add("active");
}

function goToSlide(index) {
    currentIndex = index;
    updateSlide();
}

function nextSlide() {
    currentIndex = (currentIndex + 1) % slideCount;
    updateSlide();
}

function prevSlide() {
    currentIndex = (currentIndex - 1 + slideCount) % slideCount;
    updateSlide();
}

nextBtn.addEventListener("click", nextSlide);
prevBtn.addEventListener("click", prevSlide);

// ページ表示後、最初だけ自動で進む
window.addEventListener("load", () => {
    if (firstAutoSlide) {
        setTimeout(() => {
            nextSlide();
            firstAutoSlide = false;
        }, 2000); // 2秒後に自動スライド
    }
});

// スワイプ & ドラッグ機能追加
let startX = 0;
let endX = 0;
let isDragging = false;

// スワイプ用 (スマホ)
slides.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
});

slides.addEventListener("touchend", (e) => {
    endX = e.changedTouches[0].clientX;
    handleSwipe();
});

// ドラッグ用 (PC)
slides.addEventListener("mousedown", (e) => {
    isDragging = true;
    startX = e.clientX;
});

slides.addEventListener("mouseup", (e) => {
    if (isDragging) {
        endX = e.clientX;
        handleSwipe();
        isDragging = false;
    }
});

// しきい値を超えたらスライド
function handleSwipe() {
    const diff = endX - startX;
    if (Math.abs(diff) > 50) { // ←50px以上動かしたときのみ反応
        if (diff < 0) {
            nextSlide(); // 左にドラッグ → 次のスライド
        } else {
            prevSlide(); // 右にドラッグ → 前のスライド
        }
    }
}

